module.exports = {
      id: "info-modern-icon-usage",
      viewBox: "0 0 88 88",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#info-modern-icon",
      toString: function () {
        return this.url;
      }
    }